import { createModel } from "nyax";
import { JobQueue, JobQueueQuery } from "src/models/jobQueue";
import { JobQueueEntityModel } from "src/store/models/entity/jobQueue/entity";
import { createUISideListWithPermissionModel } from "src/store/models/ui/_shared";

export const JobQueueSideUIModel = createModel(
  class extends createUISideListWithPermissionModel<JobQueue, JobQueueQuery>({
    setItems: (getContainer, items) =>
      getContainer(JobQueueEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(JobQueueEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(JobQueueEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async () => {
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: JobQueueQuery
            ) =>
              this.dependencies.serviceClient.jobQueue.list(
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
